export const successState = { loading: false, error: false, success: true }
